<script lang="ts">
  interface Props {
    id?: number;
    name: string;
    src: string;
    signedId?: string;
    onRemove: (e: MouseEvent) => void;
    remove?: boolean;
  }

  let {
    id,
    name = "image",
    src,
    signedId,
    remove = false,
    onRemove = (e: MouseEvent) => {},
  }: Props = $props()
</script>

<div class="message-image-preview" title={name} class:d-none={remove}>
  <button type="button" class="remove" onclick={onRemove}>×</button>
  <img class="attachment message_image file" alt={name} {src} />

  {#if signedId}
    <input type="hidden" name="message[images][]" value={signedId} />
  {/if}

  {#if id}
    <input type="hidden" name="message[images_attachments_attributes][][id]" value={id} />
  {/if}

  {#if remove}
    <input type="hidden" name="message[images_attachments_attributes][][_destroy]" value="1" />
  {/if}
</div>
